import template from './attachmentAdd.template.html';

export default {
  template,
  bindings: {
    ticket: '<',
    onCancelled: '&',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $timeout, $mdMedia, eventService, uiService, Document, TICKET) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.CurrentAccount = null;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.CurrentAccount = $rootScope.CurrentAccount;

        ctrl.attachments = [];
        ctrl.files = [];
        ctrl.url = TICKET.API.UPLOAD;
        ctrl.title = 'Drag & Drop file(s) here, or click to browse';
        ctrl.allowedMimeTypes = '';
        ctrl.allowedExtensions = '';
        ctrl.ticketId = ctrl.ticket.id;
        ctrl.startUpload = false;
        ctrl.startSaveProcess = false;
      };

      ctrl.uploadFinished = (files) => {
        ctrl.startUpload = false;
        ctrl.startSaveProcess = true;
        ctrl.save({ attachments: files });
      };

      ctrl.confirm = () => {
        if (
          ctrl.attachmentAdd.files &&
          ctrl.attachmentAdd.files.$viewValue &&
          ctrl.attachmentAdd.files.$viewValue.length
        ) {
          this.startUpload = true;
          this.files = ctrl.attachmentAdd.files.$viewValue;
        } else {
          uiService.toast({
            text: {
              p1: 'Attachment',
              p2: 'is not of',
              p3: 'correct type'
            },
            warn: true
          });
        }
      };

      ctrl.cancel = function () {
        ctrl.startSaveProcess = true;
        ctrl.onCancelled();
        $timeout(() => {
          ctrl.initialize();
        });
      };

      ctrl.save = function (files) {
        const len = files.attachments.length;
        for (let i = 0; i < len; i += 1) {
          const attachment = Document.blank();
          attachment.idOwner = ctrl.CurrentAccount.id;
          attachment.name = files.attachments[i].name;
          attachment.file = files.attachments[i].file;
          attachment.isNew = true;
          ctrl.attachments.push(attachment);
        }
        ctrl.onFinished({ attachments: ctrl.attachments });
        ctrl.cancel();
        uiService.toast({
          text: {
            p1: files.length > 1 ? ctrl.attachments.length : 'Attachment',
            p2: files.length > 1 ? 'attachments' : ctrl.attachments[0].getName(),
            p3: `${files.length > 1 ? 'have' : 'has'} been added`
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };
    }
  }
};
